




import Vue from 'vue';

export default Vue.extend({
  props: {
    icon: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isLocked: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      isActive: false,
    };
  },

  inject: {
    addTab: {
      from: 'addTab',
      // eslint-disable-next-line
      default: (a: any): void => {},
    },
  },

  mounted() {
    this.isActive = this.isSelected;
    // TODO investigate how we can remove this ignore
    // @ts-ignore
    this.addTab(this);
  },
});
